import { motion } from "framer-motion";
import { CHAPTERS, ABOUT_IMAGE } from "@/data/site";
import { Reveal } from "@/components/Reveal";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative bg-white px-6 py-28 md:px-12 md:py-40"
    >
      <div className="mx-auto grid max-w-[1400px] gap-16 lg:grid-cols-[0.9fr_1.1fr] lg:gap-24">
        {/* Left — sticky heading + image */}
        <div className="lg:sticky lg:top-28 lg:h-fit">
          <Reveal>
            <p className="mb-6 text-[0.7rem] uppercase tracking-[0.3em] text-sage">
              Our Philosophy
            </p>
            <h2 className="font-serif text-4xl leading-tight tracking-tight text-ink sm:text-5xl md:text-6xl">
              A gentle return
              <br />
              to <span className="italic text-forest">wellness and self-care.</span>
            </h2>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="mt-10 max-w-md overflow-hidden arch">
              <motion.img
                src={ABOUT_IMAGE}
                alt="A resilient wildflower blooming through cracked, dry earth"
                className="h-[380px] w-full object-cover object-[72%_60%] md:h-[460px]"
                initial={{ scale: 1.15 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
              />
            </div>
          </Reveal>
        </div>

        {/* Right — numbered manifesto chapters */}
        <div className="flex flex-col">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.no} delay={i * 0.05}>
              <div
                data-testid={`chapter-${c.no}`}
                className="border-t border-sage/30 py-10 md:py-14"
              >
                <div className="flex items-baseline gap-6">
                  <div>
                    <h3 className="font-serif text-3xl tracking-tight text-forest md:text-4xl">
                      {c.title}
                    </h3>
                    <p className="mt-5 max-w-xl text-base font-light leading-relaxed text-stone">
                      {c.body}
                    </p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
